import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Base_Url = process.env.REACT_APP_API_BASE_URL;


const Forget = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!email) {
            toast.warning("Email is required!");
            return;
        }

        try {
            const response = await axios.post(`${Base_Url}/users/forgot-password`, {
                email
            });
            if (response.status === 200) {
                toast.success("Mail send successfully!");
                setEmail('');
            } else {
                toast.error("Failed to send Mail");
            }
        } catch (error) {
            setLoading(false);
            console.error("error:", error);
            toast.error("Error Forget mail. Please try again.");
        }
    };

    return (
        <div className='hold-transition login-page accent-custom'>
            <ToastContainer autoClose={3000} />
            <div className="login-box login_div">
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <Link to="/" className="login_logo">
                            <img src="assets/img/logo.png" alt='logo.png' border={0} />
                        </Link>
                    </div>
                    <div className="card-body d-flex flex-row flex_flow_rowwrap align_items_cntr">
                        <div className="col-12 col-sm-12 col-md-12">
                            <h5 className="login-box-msg">Forgot Password</h5>
                            <form className="form-horizontal" onSubmit={handleSubmit}>
                                <div className="input-group mb-3">
                                    <input type="email"
                                        className="form-control"
                                        placeholder="Your Registered Email Address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <i className="fa-solid fa-user" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mt-3 text-center">
                                        <button type="submit" className="btn btn-blue btn-block" disabled={loading}>
                                            {loading ? 'Sending...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                            <p className="mb-0 text-center mt-3">
                                Go to
                                <Link to="/" className="text-center"> Login</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Forget